<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改標籤類別' : '新增標籤類別'"></page-title>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-accent float-right" @click="removeTagGroup">刪除標籤類別</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <label>顏色</label>
            <input type="color" v-model="colorHexPrefix"></input>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised" @click="$router.back()">返回</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="isEditing ? editTagGroup() : createTagGroup()">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isEditing: null,
      data: {
        name: null,
        color: null
      }
    }
  },
  components: {
    PageTitle
  },
  computed: {
    colorHexPrefix: {
      get: function () {
        if (!this.data.color) {
          return
        }
        return `#${this.data.color}`
      },
      set: function (value) {
        this.data.color = value.slice(1)
      }
    }
  },
  created: function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    if (this.isEditing) {
      this.readTagGroup(this.isEditing)
    }
  },
  methods: {
    readTagGroup: async function (tagGroupID) {
      let req = await axios.get(urls({route: 'tag-group', id: tagGroupID}), this.data)
      this.data = req.data.data
    },
    editTagGroup: async function () {
      let req = await axios.put(urls({route: 'tag-group', id: this.isEditing}), this.data)
      if (req.status === 200) {
        this.$router.push('/tag-group')
      }
    },
    createTagGroup: async function () {
      let req = await axios.post(urls({route: 'tag-group', id: this.isEditing}), this.data)
      if (req.status === 201) {
        this.$router.push('/tag-group')
      }
    },
    removeTagGroup: async function () {
      let req = await axios.delete(urls({route: 'tag-group', id: this.isEditing}))
      if (req.status === 200) {
        this.$router.push('/tag-group')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/TagGroup/TagGroupEdit.vue